module.exports = __webpack_public_path__ + "img/NL4784137.ca99f09d.png";